export {
  LEGAL_BLOCK_TYPES,
  LEGAL_DOCUMENT_KEYS,
  LEGAL_DOCUMENT_SLUGS,
  LEGAL_DOCUMENT_SLUG_BY_KEY,
  LEGAL_LOCALES,
  LEGAL_VERSION_STATUSES,
} from './legal.ts';
